import { useEffect, useState } from "react";
import { Switch } from "@headlessui/react";
import {
  classNames,
  disabledIfFieldChecker,
  disabledIfNotFieldChecker,
  isFieldEnabledChecker,
} from "../../../utils/helperFuctions";
import PopUp from "../../PopUp/PopUp";
import { config } from "../../../utils/config";
import axios from "axios";
import { getCookie } from "../../../utils/cookieHandler";

export default function InputToggle({
  label,
  name,
  id,
  defaultValue,
  err,
  handleChange,
  dataid,
  dataisnew,
  required,
  disabled,
  disabledIfField,
  disabledIfNotField,
  currentFields,
  singleLine,
  padding,
  customFontWeight,
  popupOnToggle,
  alwaysEnabledIf,
  disableAutoCalculateOnToggleOn,
  switchToFalseIfDisabled,
  disableEditForNonAdmin,
  formType,
  currentRole,
}) {
  const [popupData, setpopupData] = useState({});

  const [enabled, setEnabled] = useState(
    defaultValue === true
      ? defaultValue
      : defaultValue === "true"
      ? true
      : false
  );

  const inputChanged = async (e) => {
    const _e = {
      target: {
        name: name,
        value: e,
        dataset: {
          id: dataid,
          isnew: dataisnew,
        },
      },
    };
    if (disableAutoCalculateOnToggleOn != null) {
      if (e === true) {
        await axios.put(
          `${config.apiUrl}/api/reservations/${id}`,
          {
            auto_calculate: false,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getCookie("_AT")}`,
            },
          }
        );
      }
    }
    //console.log('ttod2: ',e)
    if (popupOnToggle != null) {
      setpopupData({
        isError: true,
        title: popupOnToggle.title,
        description:
          e === true ? popupOnToggle.TurnOnBody : popupOnToggle.TurnOffBody,
        showPopUp: true,
        takeActionText: "Yes",
        takeActionFun: () => {
          setEnabled(e);
          handleChange(_e);
        },
      });
    } else {
      setEnabled(e);
      handleChange(_e, false);
    }
  };
  const isFieldDisabled =
    disabledIfField != null
      ? disabled ||
        disabledIfFieldChecker(currentFields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : disabled ?? false;

  const fieldDisabledIfNot =
    disabledIfNotField != null
      ? disabled ||
        disabledIfNotFieldChecker(currentFields, {
          field: disabledIfNotField.field,
          valuesArray: disabledIfNotField.isNotEqual,
        })
      : disabled ?? false;

  const isEnabled = (alwaysEnabledIf) => {
    let enabled = true;
    alwaysEnabledIf.forEach((item) => {
      const isEn = isFieldEnabledChecker(currentFields, {
        field: item.field,
        value: item.isEqual,
      });
      if (isEn === false) {
        enabled = false;
      }
    });
    return enabled;
  };

  let isFieldDisabledEnd =
    alwaysEnabledIf != null
      ? isEnabled(alwaysEnabledIf) === false &&
        (isFieldDisabled || fieldDisabledIfNot)
      : isFieldDisabled || fieldDisabledIfNot;
  if (
    disableEditForNonAdmin != null &&
    disableEditForNonAdmin === true &&
    currentRole !== process.env.REACT_APP_ADMIN_ROLE &&
    formType === "edit"
  ) {
    isFieldDisabledEnd = true;
  }
  // const fieldDisabledIfNot =
  //   disabledIfNotField != null
  //     ? disabledIfNotFieldChecker(currentFields, disabledIfNotField)
  //     : false;
  // console.log("fieldDisabledIfNot: ", fieldDisabledIfNot);
  useEffect(() => {
    if (switchToFalseIfDisabled === true && isFieldDisabledEnd === true) {
      inputChanged(false);
    }
  }, [switchToFalseIfDisabled, isFieldDisabledEnd, setEnabled]);

  return (
    <div
      className={`text-left ${
        singleLine === true && "flex justify-between px-4"
      } ${padding === true && "py-5 border-b border-gray-200"}`}
    >
      <label
        htmlFor={name}
        style={{
          fontWeight: customFontWeight != null ? customFontWeight : 500,
        }}
        className="block text-sm leading-6 text-gray-900"
      >
        {label}
        {required ? "*" : ""}
      </label>
      <Switch
        style={{
          cursor: isFieldDisabledEnd ? "not-allowed" : "pointer",
          opacity: isFieldDisabledEnd ? "30%" : "100%",
        }}
        disabled={isFieldDisabledEnd}
        checked={enabled === true ? true : false}
        onChange={inputChanged}
        name={name}
        id={id}
        data-id={dataid}
        data-isnew={dataisnew}
        className={classNames(
          enabled === true ? "bg-primary" : "bg-gray-200",
          "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
        )}
      >
        <span className="sr-only">{label}</span>
        <span
          aria-hidden="true"
          className={classNames(
            enabled === true ? "translate-x-5" : "translate-x-0",
            "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
          )}
        />
      </Switch>
      {err && <p className="mt-2 text-sm text-red-600">{err}</p>}
      <PopUp
        onSuccess={popupData.onSuccess}
        isError={popupData.isError}
        title={popupData.title}
        description={popupData.description}
        formOptions={popupData.formOptions}
        takeActionText={popupData.takeActionText}
        takeActionFun={popupData.takeActionFun}
        showPopUp={popupData.showPopUp}
        hidePopUp={() => {
          setpopupData({});
        }}
        formSubmit={popupData.formSubmit}
        formConcatData={popupData.formConcatData}
        propName={popupData.propName}
        disabledForm={popupData.disabledForm}
        hideCancel={popupData.hideCancel}
        hideMainButton={popupData.hideMainButton}
        showLoading={popupData.hideMainButton}
        progressValue={popupData.progressValue}
      >
        {popupData.children}
      </PopUp>
    </div>
  );
}
